<template>
  <v-card class="pt-6 pb-3 px-6">
    <v-row>
      <v-col cols="12" lg="2">
        <v-text-field
          :label="$vuetify.lang.t('$vuetify.ecoChallengeList.id')"
          outlined
          single-line
          hide-details
          clearable
          v-model="filterQuery.externalId"
          autocomplete="off"
        />
      </v-col>
      <v-col cols="12" lg="2">
        <v-text-field
          :label="$vuetify.lang.t('$vuetify.ecoChallengeList.name')"
          outlined
          single-line
          hide-details
          clearable
          v-model="filterQuery.firstName"
          autocomplete="off"
        />
      </v-col>
      <v-col cols="12" lg="2">
        <v-text-field
          :label="$vuetify.lang.t('$vuetify.ecoChallengeList.surname')"
          outlined
          single-line
          hide-details
          clearable
          v-model="filterQuery.lastName"
          autocomplete="off"
        />
      </v-col>
      <v-col cols="12" lg="2">
        <v-text-field
          :label="$vuetify.lang.t('$vuetify.ecoChallengeList.email')"
          outlined
          single-line
          hide-details
          clearable
          v-model="filterQuery.email"
          autocomplete="off"
        />
      </v-col>
      <v-col>
        <v-autocomplete
          :items="getTypes"
          outlined
          chips
          small-chips
          :label="$vuetify.lang.t('$vuetify.ecoChallengeList.type')"
          multiple
          hide-details
          v-model="filterQuery.type"
          autocomplete="off"
        ></v-autocomplete>
      </v-col>
      <v-col>
        <v-autocomplete
          :items="getStatus"
          outlined
          chips
          small-chips
          :label="$vuetify.lang.t('$vuetify.ecoChallengeList.status')"
          multiple
          hide-details
          v-model="filterQuery.status"
          autocomplete="off"
        ></v-autocomplete>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-menu
          v-model="popupFrom"
          :close-on-content-click="false"
          :nudge-right="35"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <div>
              <v-text-field
                :label="$vuetify.lang.t('$vuetify.searchOrder.createdAtFrom')"
                hide-details
                :value="formatDate(filterQuery.createdAt.from)"
                outlined
                readonly
                v-on="on"
                @click:clear="$set(filterQuery.createdAt, 'from', null)"
                clearable
              />
            </div>
          </template>
          <v-date-picker
            v-model="filterQuery.createdAt.from"
            @input="popupFrom = false"
            locale="cs-CZ"
            :first-day-of-week="1"
          />
        </v-menu>
      </v-col>
      <v-col>
        <v-menu
          v-model="popupTo"
          :close-on-content-click="false"
          :nudge-right="35"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <div>
              <v-text-field
                :label="$vuetify.lang.t('$vuetify.searchOrder.createdAtTo')"
                hide-details
                :value="formatDate(filterQuery.createdAt.to)"
                outlined
                readonly
                v-on="on"
                @click:clear="$set(filterQuery.createdAt, 'to', null)"
                clearable
              />
            </div>
          </template>
          <v-date-picker
            v-model="filterQuery.createdAt.to"
            @input="popupTo = false"
            locale="cs-CZ"
            :first-day-of-week="1"
          />
        </v-menu>
      </v-col>
    </v-row>

    <div class="filter-container pt-2">
      <button @click="clear()" class="v-btn v-btn--contained theme--light v-size--default error mt-3 mb-3">
        {{ $vuetify.lang.t('$vuetify.searchOrder.delete_filter') }}
      </button>
      <button
        @click="getItems()"
        ref="getItemsBtn"
        class="v-btn v-btn--contained theme--light v-size--default primary mt-3 mb-3"
      >
        {{ $vuetify.lang.t('$vuetify.searchOrder.filter') }}
      </button>
    </div>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import {formatDate} from "@/common/helpers/date";

import TableStateManager from '../../common/helpers/tableStateManager';

import ECO_CHALLENGE_STATUS from '../../common/enums/ecoChallengeStatus';
import ECO_CHALLENGE_TYPES from '../../common/enums/ecoChallengeTypes';

export default {
  name: 'OrdersFilter',

  data() {
    return {
      ECO_CHALLENGE_STATUS,
      ECO_CHALLENGE_TYPES,
      items: [],
      loading: true,
      selectLoading: {
        types: false,
      },
      filterQuery: { price: {}, createdAt: {} },
      popupFrom: false,
      popupTo: false,
    };
  },

  computed: {
    ...mapGetters({

    }),

    getTypes() {
      if (ECO_CHALLENGE_TYPES) {
        return Object.keys(ECO_CHALLENGE_TYPES).map(key => ({
          text: this.$vuetify.lang.t('$vuetify.ecoChallengeType.' + ECO_CHALLENGE_TYPES[key]),
          value: ECO_CHALLENGE_TYPES[key]
        }));
      }
      return [];
    },

    getStatus() {
      if (ECO_CHALLENGE_STATUS) {
        return Object.keys(ECO_CHALLENGE_STATUS).map(key => ({
          text: this.$vuetify.lang.t('$vuetify.ecoChallengeStatus.' + ECO_CHALLENGE_STATUS[key]),
          value: ECO_CHALLENGE_STATUS[key]
        }));
      }
      return [];
    },
  },

  watch: {
    filterQuery: {
      deep: true,
      handler(val) {
        const tableState = TableStateManager.getTableState('eco');
        const newFilterQuery = Object.entries(val).reduce((acc, [key, value]) => {
          if (!value || (Array.isArray(value) && !value.length)) {
            return acc;
          }
          acc[key] = value;
          return acc;
        }, {});

        TableStateManager.setTableState('eco', {
          ...tableState,
          filterQuery: newFilterQuery,
        });
      },
    },
  },

  methods: {
    ...mapActions({

    }),

    formatDate,

    clear() {
      this.filterQuery = { price: {}, createdAt: {} };
      this.getItems();
    },

    getItems() {
      this.$emit('getItems', this.filterQuery);

      const tableState = TableStateManager.getTableState('eco');

      TableStateManager.setTableState('eco', {
        ...tableState,
        filterQuery: this.filterQuery,
      });
    },
  },

  created() {
    const { filterQuery } = TableStateManager.getTableState('eco');
    this.filterQuery = filterQuery || { price: {}, createdAt: {} };
  },
};
</script>

<style lang="scss" scoped>
.filter-container {
  display: flex;
  justify-content: space-between;
}
</style>
